<template>
    <div>
        <header>
            <b-container class="pt-5 pb-4">

            </b-container>
        </header>

        <b-container class="mt-5 pb-5 mb-5">
            <h4 class="mb-5"><i class="far fa-id-badge mr-3"></i>Your Registrations & Records</h4>

            <b-card class="conference mb-3" v-for="reg in registrations">
                <b-row>
                    <b-col cols="7">
                        <h6>{{reg.conference.title}} <b-badge variant="light" class="ml-3"><i class="fas fa-tag mr-2"></i>{{reg.conference.code}}</b-badge></h6>
                        <div>{{reg.conference.startAt | moment('dddd, MMMM Do, YYYY')}} - {{reg.conference.endAt | moment('dddd MMMM Do, YYYY')}}</div>
                    </b-col>
                    <b-col class="text-right">
                        <b-button variant="success" class="mr-2" :to="{name: 'conf-info', params: {id: reg.conference.id, code: reg.codeSecret}}"><i class="fas fa-search mr-2"></i> Registration</b-button>
                    </b-col>
                </b-row>
            </b-card>
        </b-container>

        <footer class="pt-3 pb-2">
            <div class="mt-3">
                <router-link to="/"><img src="@/assets/logo_white.png" class="logo mt-4"/></router-link>
            </div>

            <copyright class="mt-3 mb-5"/>
        </footer>
    </div>
</template>

<script>
    import Copyright from "../components/Copyright";
    import {mapActions} from "vuex";

    export default {
        name: "register-success",
        components: {Copyright},
        props: ['id', 'code'],
        data: function () {
            return {
                registrations: []
            }
        },
        methods: {
            ...mapActions(['getRecords'])
        },
        mounted: function () {
            this.getRecords(this.code).then(records => {
                this.registrations = records;
            }, err => {
                console.error(err);
            });
        }
    }
</script>

<style lang="scss" scoped>

    @import '~@/assets/scss/_variables.scss';

    header {
        background: $green;
        color: white;
        background: linear-gradient(to bottom, darken($green, 10) 0%, $green 75%, #FFF 75%, white 80%, white 100%);
    }

    .meta {
        font-size: 0.9rem;
    }

    h4 {
        color: $success;
    }

    footer {
        text-align: center;
        background: darken($green, 10);
    }

    .fa-exclamation-triangle {
        color: orangered;
    }
</style>
